"use client";

import MoreThanResourceSection from "@/app/(core)/components/MoreThanResourceSection";
import PageSection from "@/app/(core)/components/PageSection";
import SectionHeader from "@/app/(core)/components/SectionHeader";
import TrustedBySchoolsSection from "@/app/(core)/components/TrustedBySchoolsSection";
import WaveBanner from "@/app/components/footer/components/WaveBanner";
import { StripeProductMetadata } from "@/types/product-schema";
import { darken, useComputedColorScheme, useMantineTheme } from "@mantine/core";
import { CreateMembershipFormSubjectMeta } from "../../register/membership/page";
import classes from "./pricing-content.module.css";
import PricingSection from "./PricingSection";

interface PricingContentProps {
  stripeProducts: StripeProductMetadata;
  subjectMeta: CreateMembershipFormSubjectMeta;
}

export default function PricingContent({
  stripeProducts,
  subjectMeta,
}: PricingContentProps) {
  const theme = useMantineTheme();
  const colorScheme = useComputedColorScheme("light");

  return (
    <main>
      {/* 1. Pricing plans - dark like about/team first section */}
      <PageSection variant="dark" firstSection>
        <SectionHeader
          title="Unbeatable, Transparent Pricing."
          subTitle="Choose the plan that fits your goals. All plans include a 7-day free trial."
          align="center"
          needsLightTitle={true}
          isFirstSection
        />
        <div className={classes.pricingWrap}>
          <PricingSection
            stripeProducts={stripeProducts}
            subjectMeta={subjectMeta}
          />
        </div>
      </PageSection>
      <WaveBanner
        colors={{
          light: theme.colors.darkblue[9],
          dark: darken(theme.colors.darkblue[9], 0.3),
        }}
        bgColor={
          colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
        }
      />

      {/* More than just a resource site - scroll-driven feature tabs */}
      <MoreThanResourceSection />
      <WaveBanner
        colors={{ light: theme.colors.gray[0], dark: theme.colors.dark[8] }}
        bgColor={
          colorScheme === "dark"
            ? darken(theme.colors.darkblue[9], 0.3)
            : theme.colors.darkblue[9]
        }
      />

      {/* 2. Schools / trust - dark to alternate after gray section */}
      <TrustedBySchoolsSection />
      <WaveBanner
        colors={{
          light: theme.colors.darkblue[9],
          dark: darken(theme.colors.darkblue[9], 0.3),
        }}
        bgColor={
          colorScheme === "dark"
            ? theme.colors.dark[9]
            : darken(theme.colors.darkblue[9], 0.2)
        }
      />
    </main>
  );
}
